import { styled } from '@vw-marketing/us-components';

export const StyledAppContainer = styled.div`
  z-index: 0;
`;
